import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_OFFBOARDING_CHECKLIST, SET_ERRORMSG } from '@/store/mutation_types';
import { TOGGLE_EMPLOYEE_OFFBOARDING_CHECKLIST_STATUS } from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeOffboardingChecklist from '@/services/employee_offboarding_checklist';
import { Module } from 'vuex';
import { ToggleEmployeeOffboardingChecklistStatus } from '@/dtos/employee_offboarding_checklist.dto';

const employeeOffboardingChecklist: Module<any, {}> = {
  state: {
    employeeOffboardingChecklist: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeOffboardingChecklist: (state: { employeeOffboardingChecklist: any }) =>
      state.employeeOffboardingChecklist,
  },
  mutations: {
    [SET_EMPLOYEE_OFFBOARDING_CHECKLIST]: (
      state: { employeeOffboardingChecklist: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null
        ? (state.employeeOffboardingChecklist.data = payload.data)
        : null,
        (state.employeeOffboardingChecklist.isLoading = payload.isLoading);
    },
  },
  actions: {
    [TOGGLE_EMPLOYEE_OFFBOARDING_CHECKLIST_STATUS]: async (
      { commit }: any,
      payload: any
    ) => {
      commit(SET_EMPLOYEE_OFFBOARDING_CHECKLIST, { data: null, isLoading: true });

      const result: AxiosResponse =
        await EmployeeOffboardingChecklist.toggleStatus(
          payload as ToggleEmployeeOffboardingChecklistStatus
        );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING_CHECKLIST, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING_CHECKLIST, {
          data: null,
          isLoading: false,
        });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING_CHECKLIST, { isLoading: false });
        return false;
      }
    },
  },
};

export default employeeOffboardingChecklist;
